(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[36280],{

/***/ 20221:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[username]",
      function () {
        return __webpack_require__(61186);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 61186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var global_DocumentLayout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91646);
/* harmony import */ var global_Common_If__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3897);
/* harmony import */ var global_MainLayout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74317);
/* harmony import */ var global_SEO__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26350);
/* harmony import */ var hooks_useProtectedRoute__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56198);
/* harmony import */ var features_user_Guest_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66965);


__webpack_require__(14473);







var GuestUserPage = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(97570), __webpack_require__.e(23304), __webpack_require__.e(63828), __webpack_require__.e(33082), __webpack_require__.e(51767), __webpack_require__.e(97081), __webpack_require__.e(86252), __webpack_require__.e(57333), __webpack_require__.e(5406), __webpack_require__.e(74645), __webpack_require__.e(71682), __webpack_require__.e(62114), __webpack_require__.e(66933), __webpack_require__.e(63693), __webpack_require__.e(41232), __webpack_require__.e(82583), __webpack_require__.e(3841), __webpack_require__.e(51882)]).then(__webpack_require__.bind(__webpack_require__, 97052));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97052)
            ];
        }
    }
});
var PageLoader = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 598).then(__webpack_require__.bind(__webpack_require__, 598));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(598)
            ];
        }
    },
    ssr: false
});
var User = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(97570), __webpack_require__.e(60296), __webpack_require__.e(23304), __webpack_require__.e(63828), __webpack_require__.e(33082), __webpack_require__.e(51767), __webpack_require__.e(97081), __webpack_require__.e(86252), __webpack_require__.e(57333), __webpack_require__.e(5406), __webpack_require__.e(46066), __webpack_require__.e(37555), __webpack_require__.e(74645), __webpack_require__.e(71682), __webpack_require__.e(62114), __webpack_require__.e(66933), __webpack_require__.e(63693), __webpack_require__.e(41232), __webpack_require__.e(82583), __webpack_require__.e(14467), __webpack_require__.e(3841), __webpack_require__.e(42293), __webpack_require__.e(86206)]).then(__webpack_require__.bind(__webpack_require__, 55232));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55232)
            ];
        }
    },
    ssr: false
});
function UserPage(param) {
    var username = param.username, user = param.user, isLoggedIn = param.isLoggedIn;
    var ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_SEO__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, (0,features_user_Guest_utils__WEBPACK_IMPORTED_MODULE_7__/* .generateMetatags */ .eD)(user))),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Common_If__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                condition: !isLoggedIn,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_DocumentLayout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    noBox: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GuestUserPage, {
                        username: username,
                        user: user
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Common_If__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                condition: isLoggedIn,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(global_MainLayout__WEBPACK_IMPORTED_MODULE_4__["default"], {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageLoader, {
                            loaded: isLoggedIn && ((ref = (0,hooks_useProtectedRoute__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)()) === null || ref === void 0 ? void 0 : ref.isLoaded)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(User, {
                            username: username
                        })
                    ]
                })
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (UserPage);


/***/ }),

/***/ 10567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97751);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-card-body {\n    padding: 20px;\n  }\n\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n  flex-direction: column;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Box = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-3a0d262d-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);
/* harmony default export */ __webpack_exports__["Z"] = (Box);


/***/ }),

/***/ 30079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T3": function() { return /* binding */ Page; },
/* harmony export */   "V3": function() { return /* binding */ privacyPageTheme; }
/* harmony export */ });
/* unused harmony export Theme */
var theme = {};
var Theme;
(function(Theme) {
    Theme["dark"] = "dark";
    Theme["light"] = "light";
})(Theme || (Theme = {}));
var Page;
(function(Page) {
    Page["privacyDark"] = "privacy-page-dark";
    Page["privacyLight"] = "privacy-page-light";
})(Page || (Page = {}));
var privacyPageTheme = {
    dark: {
        page: Page.privacyDark,
        textPrimary: "#cbcbcb",
        textSecondary: "#858585",
        backgroundPrimary: "#121212",
        backgroundSecondary: "#121212",
        borderPrimary: "#121212"
    },
    light: {
        page: Page.privacyLight,
        textPrimary: "#333333",
        textSecondary: "#858585",
        backgroundPrimary: "#ffffff",
        backgroundSecondary: "#f2f2f2",
        borderPrimary: "#dadada"
    }
};

/* harmony default export */ __webpack_exports__["ZP"] = (theme);


/***/ }),

/***/ 66965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lt": function() { return /* binding */ extractUserData; },
/* harmony export */   "eD": function() { return /* binding */ generateMetatags; }
/* harmony export */ });
/* unused harmony export isUsername */
/* harmony import */ var global_SEO_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54154);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);


var generateMetatags = function(user) {
    if (!(user === null || user === void 0 ? void 0 : user.profile)) return global_SEO_constants__WEBPACK_IMPORTED_MODULE_0__/* .defaultMetaTags */ .x;
    var profile = user.profile;
    var title = "".concat(profile === null || profile === void 0 ? void 0 : profile.fullname, " (").concat(profile === null || profile === void 0 ? void 0 : profile.username, ")");
    var _default_url;
    var image = (_default_url = profile.avatar_urls.default_url) !== null && _default_url !== void 0 ? _default_url : "";
    return {
        title: title,
        url: "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .SITE_URL */ ._O, "/").concat(profile === null || profile === void 0 ? void 0 : profile.username),
        image: image
    };
};
var extractUserData = function(userData) {
    var ref = (userData === null || userData === void 0 ? void 0 : userData.profile) || {}, username = ref.username, fullname = ref.fullname, avatar_urls = ref.avatar_urls;
    var ref1 = (userData === null || userData === void 0 ? void 0 : userData.statistic) || {}, idea_count = ref1.idea_count, follower_count = ref1.follower_count;
    var avatarUrl = (avatar_urls === null || avatar_urls === void 0 ? void 0 : avatar_urls.default_url.startsWith("http")) ? avatar_urls === null || avatar_urls === void 0 ? void 0 : avatar_urls.default_url : "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .AVATAR_URL */ .q$, "/").concat((avatar_urls === null || avatar_urls === void 0 ? void 0 : avatar_urls.default_url) || "");
    return {
        username: username,
        fullname: fullname,
        avatarUrl: avatarUrl,
        ideaCount: idea_count,
        followerCount: follower_count,
        userData: userData
    };
};
var isUsername = function(str) {
    var regex = /^[a-zA-Z0-9]+$/i;
    if (regex.test(str)) {
        return str.toLowerCase();
    }
    return false;
};


/***/ }),

/***/ 3897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isElementTypeOf */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var isElementTypeOf = function(target, element) {
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.isValidElement)(target) && target.type === element;
};
var Else = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
};
var If = function(props) {
    var condition = props.condition, children = props.children;
    if (condition) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: react__WEBPACK_IMPORTED_MODULE_1__.Children.toArray(children).filter(function(child) {
                return !isElementTypeOf(child, Else);
            })
        });
    }
    return react__WEBPACK_IMPORTED_MODULE_1__.Children.map(children, function(child) {
        if (isElementTypeOf(child, Else)) {
            return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(child);
        }
        return null;
    });
};
If.Else = Else;
/* harmony default export */ __webpack_exports__["Z"] = (If);


/***/ }),

/***/ 91646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ global_DocumentLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/@deprecated-ui/statics/Box.js
var Box = __webpack_require__(10567);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/config/theme.ts
var config_theme = __webpack_require__(30079);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/device.js
var device = __webpack_require__(74575);
;// CONCATENATED MODULE: ./src/global/DocumentLayout/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  width: 100%;\n\n  a {\n    color: ",
        ";\n    text-decoration: none;\n    margin: 8px 4px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: 10px;\n  min-height: 100vh;\n\n  ",
        "\n\n  @media ",
        " {\n    padding: 20px 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: center;\n\n  @media ",
        " {\n    justify-content: space-between;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var Footer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a7cedde8-0"
})(_templateObject(), color/* default.highempahis */.Z.highempahis, function(param) {
    var theme = param.theme;
    if (theme.page === config_theme/* Page.privacyDark */.T3.privacyDark) {
        return " \n        color: ".concat(theme.textPrimary, ";\n        background: ").concat(theme.backgroundSecondary, ";\n        \n        div {\n          background: ").concat(theme.backgroundSecondary, ";\n        }\n\n        a {\n          color: ").concat(theme.textPrimary, ";\n        }\n      ");
    }
    return "";
});
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a7cedde8-1"
})(_templateObject1(), color/* default.whiteSmoke */.Z.whiteSmoke, function(param) {
    var theme = param.theme;
    if (theme.page === config_theme/* Page.privacyDark */.T3.privacyDark) {
        return " \n      background: ".concat(theme.backgroundSecondary, ";\n      \n      div {\n        background: ").concat(theme.backgroundSecondary, ";\n      }\n\n      h1, h2, h3, ol, li, p {\n        color: ").concat(theme.textPrimary, ";\n      }\n\n      .ant-card-bordered {\n        border: 1px solid #333333;\n      }\n    ");
    }
    return "";
}, device/* default.tablet */.Z.tablet);
var Header = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-a7cedde8-2"
})(_templateObject2(), device/* default.tablet */.Z.tablet);


;// CONCATENATED MODULE: ./src/global/DocumentLayout/__tests__/constant.ts
var DATA_CY_DOCUMENT_LAYOUT = "document-layout";

;// CONCATENATED MODULE: ./src/global/DocumentLayout/index.tsx














var DocumentLayout = function(param) {
    var children = param.children, _noBox = param.noBox, noBox = _noBox === void 0 ? false : _noBox, _noAuth = param.noAuth, noAuth = _noAuth === void 0 ? false : _noAuth, _className = param.className, className = _className === void 0 ? "" : _className;
    var date = new Date();
    var year = date.getFullYear();
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var customPageTheme = theme;
    var stockbitLogo = (0,react.useMemo)(function() {
        return customPageTheme.page === config_theme/* Page.privacyDark */.T3.privacyDark ? "/images/stockbit-white.svg" : "/images/stockbit.svg";
    }, [
        customPageTheme.page
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        className: className,
        "data-cy": DATA_CY_DOCUMENT_LAYOUT,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                align: "center",
                direction: "row",
                justify: "space-between",
                // @ts-expect-error
                mx: "auto",
                p: "20px 10px",
                style: {
                    maxWidth: "930px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                id: "header-stockbit-logo",
                                src: stockbitLogo,
                                height: "40px",
                                alt: "Stockbit"
                            })
                        })
                    }),
                    !noAuth && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        direction: "row",
                        justify: "center",
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/login",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        type: "borderless",
                                        mr: "16px",
                                        mt: "8px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            weight: "bold",
                                            family: "bold",
                                            color: color/* default.pinkSwan */.Z.pinkSwan,
                                            children: "Login"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/register",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        type: "primary",
                                        mt: "8px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            family: "bold",
                                            color: "#fff",
                                            children: "Register"
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                mx: "auto",
                mb: "24px",
                style: {
                    maxWidth: "930px"
                },
                children: noBox ? children : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    style: {
                        width: "100%"
                    },
                    children: children
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer, {
                    children: [
                        "2013-",
                        year,
                        " Stockbit \xb7",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/about",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: "About"
                            })
                        }),
                        "\xb7",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/contact",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: "Contact"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://help.stockbit.com/id",
                            children: "Help"
                        }),
                        "\xb7",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/rules",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: "House Rules"
                            })
                        }),
                        "\xb7",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/terms",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: "Terms"
                            })
                        }),
                        "\xb7",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/privacy",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: "Privacy"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
DocumentLayout.propTypes = {
    children: (prop_types_default()).node.isRequired,
    noBox: (prop_types_default()).bool,
    noAuth: (prop_types_default()).bool
};
DocumentLayout.defaultProps = {
    noBox: false,
    noAuth: false
};
/* harmony default export */ var global_DocumentLayout = (DocumentLayout);


/***/ }),

/***/ 54154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ glossaryMetaTags; },
/* harmony export */   "x": function() { return /* binding */ defaultMetaTags; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);


var defaultMetaTags = {
    title: "Stockbit - Investasi Saham Bersama Komunitas Saham Terbesar di Indonesia",
    description: "Aplikasi saham untuk berdiskusi, analisa dan berinvestasi dengan harga real time, berita terkini, riset, data fundamental, charting, dan analytical tools yang lengkap",
    keywords: "stockbit, investasi, saham, pasar modal, pasar saham, harga saham, belajar investasi, belajar saham, nabung saham, rekomendasi saham, belajar trading, virtual trading, komunitas saham, ihsg, berita saham, analisa saham, jual beli saham, bei, bursa saham indonesia, idx, professional tools, tools saham, saham bumi, reksadana, jkse",
    image: "https://stockbit.com/assets/img/stockbit.jpg",
    url: "https://stockbit.com"
};
var glossaryMetaTags = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, defaultMetaTags), {
    title: "Stockbit Glossary | Stockbit - Kamus Investasi Saham",
    url: "https://stockbit.com/glossary"
});
// eslint-disable-next-line import/prefer-default-export



/***/ }),

/***/ 26350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86123);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54154);







function SEO(param) {
    var title = param.title, description = param.description, keywords = param.keywords, image = param.image, url = param.url, schemaJson = param.schemaJson, customTitle = param.customTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title !== _constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags.title */ .x.title && !schemaJson && !customTitle ? "".concat(title, " | ").concat(_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags.title */ .x.title) : title
            }),
            constants_app__WEBPACK_IMPORTED_MODULE_2__/* .isProduction */ .yv ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "index, follow"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex, nofollow"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "revisit",
                content: "1 days"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "revisit-after",
                content: "1 days"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "resource-type",
                content: "document"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "audience",
                content: "general"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "content-language",
                content: "id-ID"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "web_author",
                content: "Stockbit"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "copyright",
                content: "Stockbit"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "google",
                content: "notranslate"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "google-site-verification",
                content: "n9LVcB1gB0We60y2dG78-koFgM8y_mrf9pw1hrKsxFA"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "fb:app_id",
                content: constants_api__WEBPACK_IMPORTED_MODULE_1__/* .FACEBOOK_APP_ID */ .lZ
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:secure_url",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: image
            }),
            schemaJson ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(schemaJson)
                }
            }) : null
        ]
    });
}
SEO.defaultProps = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, _constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags */ .x), {
    customTitle: false
});
/* harmony default export */ __webpack_exports__["Z"] = (SEO);


/***/ }),

/***/ 56198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2497);
/* harmony import */ var lib_entities_credentials__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64435);
/* harmony import */ var utils_auth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19225);




//  Utils

function useProtectedRoute() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isLoaded = ref[0], setIsLoaded = ref[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var isLoggedIn = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(lib_entities_credentials__WEBPACK_IMPORTED_MODULE_3__/* .selectors */ .wl).isLoggedIn;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        var token = utils_auth__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getToken */ .Z.getToken();
        if (!isLoggedIn && !(token === null || token === void 0 ? void 0 : (ref = token.accessToken) === null || ref === void 0 ? void 0 : ref.token)) {
            // @ts-ignore
            dispatch(lib_entities_credentials__WEBPACK_IMPORTED_MODULE_3__/* .effects.logout */ .Sz.logout());
            router.push("/login");
            return;
        }
        setIsLoaded(true);
    }, [
        dispatch,
        isLoggedIn,
        router
    ]);
    return {
        isLoaded: isLoaded
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useProtectedRoute);


/***/ }),

/***/ 20:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/backpack/1.0.0/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["backpack"]) {
      return resolve(window.remoteLoading["backpack"])
    }

    var res, rej;
    window.remoteLoading["backpack"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["backpack"] !== 'undefined') {
      res(window["backpack"]);
      return resolve(window["backpack"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["backpack"] !== 'undefined') {
          res(window["backpack"]);
          return resolve(window["backpack"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "backpack"
    );
  }).then(function () {
    const proxy = {
      get: backpack.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          backpack.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        backpack.__initialized = true
      }
    }
    if (!backpack.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 29191:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/buy-sell/1.7.12/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["buysell"]) {
      return resolve(window.remoteLoading["buysell"])
    }

    var res, rej;
    window.remoteLoading["buysell"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["buysell"] !== 'undefined') {
      res(window["buysell"]);
      return resolve(window["buysell"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["buysell"] !== 'undefined') {
          res(window["buysell"]);
          return resolve(window["buysell"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "buysell"
    );
  }).then(function () {
    const proxy = {
      get: buysell.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          buysell.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        buysell.__initialized = true
      }
    }
    if (!buysell.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 63329:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/fast-trade/3.0.3/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["fasttrade"]) {
      return resolve(window.remoteLoading["fasttrade"])
    }

    var res, rej;
    window.remoteLoading["fasttrade"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["fasttrade"] !== 'undefined') {
      res(window["fasttrade"]);
      return resolve(window["fasttrade"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["fasttrade"] !== 'undefined') {
          res(window["fasttrade"]);
          return resolve(window["fasttrade"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "fasttrade"
    );
  }).then(function () {
    const proxy = {
      get: fasttrade.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          fasttrade.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        fasttrade.__initialized = true
      }
    }
    if (!fasttrade.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 30018:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/insider-activity/1.0.1/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["insideractivity"]) {
      return resolve(window.remoteLoading["insideractivity"])
    }

    var res, rej;
    window.remoteLoading["insideractivity"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["insideractivity"] !== 'undefined') {
      res(window["insideractivity"]);
      return resolve(window["insideractivity"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["insideractivity"] !== 'undefined') {
          res(window["insideractivity"]);
          return resolve(window["insideractivity"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "insideractivity"
    );
  }).then(function () {
    const proxy = {
      get: insideractivity.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          insideractivity.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        insideractivity.__initialized = true
      }
    }
    if (!insideractivity.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 6019:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/movers/1.0.4/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["movers"]) {
      return resolve(window.remoteLoading["movers"])
    }

    var res, rej;
    window.remoteLoading["movers"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["movers"] !== 'undefined') {
      res(window["movers"]);
      return resolve(window["movers"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["movers"] !== 'undefined') {
          res(window["movers"]);
          return resolve(window["movers"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "movers"
    );
  }).then(function () {
    const proxy = {
      get: movers.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          movers.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        movers.__initialized = true
      }
    }
    if (!movers.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 85611:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/top-stocks/1.0.1/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["topstocks"]) {
      return resolve(window.remoteLoading["topstocks"])
    }

    var res, rej;
    window.remoteLoading["topstocks"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["topstocks"] !== 'undefined') {
      res(window["topstocks"]);
      return resolve(window["topstocks"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["topstocks"] !== 'undefined') {
          res(window["topstocks"]);
          return resolve(window["topstocks"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "topstocks"
    );
  }).then(function () {
    const proxy = {
      get: topstocks.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          topstocks.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        topstocks.__initialized = true
      }
    }
    if (!topstocks.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [74885,63332,25287,94119,78656,71577,75819,46819,42871,12603,7648,25935,97751,80129,51225,36661,27251,53954,29117,50626,46406,20228,67555,78497,265,91036,54253,48761,19636,6916,64435,48308,72454,70814,74768,40927,77284,74317,71790,49774,92888,40179], function() { return __webpack_exec__(20221); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);